import { useNavigate } from "react-router-dom";
import SnapReceiptButton from "./ReceiptCapture.jsx";
import CardScanButton, { cardFieldsToPrefill, isLowConfidence } from "./CardScan.jsx";

const rowCls =
  "flex w-full items-center gap-3 rounded-xl px-4 py-3.5 text-left text-base font-medium text-slate-800 active:bg-slate-100 disabled:opacity-50";

function Row({ icon, label, onClick }) {
  return (
    <button type="button" onClick={onClick} className={rowCls}>
      <span className="text-xl">{icon}</span>
      {label}
    </button>
  );
}

// Universal quick-add sheet, opened from the bottom nav's Add button on every
// page. Reuses the existing camera components for receipt/card capture so the
// same upload+OCR path runs no matter where the snap was started from.
export default function AddMenu({ onClose }) {
  const navigate = useNavigate();
  const go = (path, state) => {
    onClose();
    navigate(path, state ? { state } : undefined);
  };

  return (
    <div className="fixed inset-0 z-20 flex items-end justify-center">
      <button aria-label="Close" onClick={onClose} className="absolute inset-0 bg-black/40" />
      <div className="safe-bottom relative w-full max-w-lg rounded-t-3xl bg-white pb-2 pt-3 shadow-xl">
        <div className="mx-auto mb-2 h-1.5 w-12 rounded-full bg-slate-200" />
        <p className="px-4 pb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Quick add</p>
        <div className="divide-y divide-slate-100">
          <SnapReceiptButton label="📷 Snap receipt" className={rowCls} onCaptured={({ id }) => go(`/receipts/${id}/review`)} />
          <Row icon="💵" label="Expense / income entry" onClick={() => go("/add")} />
          <Row icon="👤" label="Add contact" onClick={() => go("/crm/new")} />
          <CardScanButton
            label="📇 Scan business card"
            className={rowCls}
            onExtracted={(fields) =>
              go("/crm/new", { prefill: cardFieldsToPrefill(fields), lowConfidence: isLowConfidence(fields) })
            }
          />
          <Row icon="🧾" label="New invoice" onClick={() => go("/money?tab=invoices&new=1")} />
          <Row icon="🤝" label="Add engagement" onClick={() => go("/crm?tab=pipeline&new=1")} />
          <Row icon="✅" label="Add follow-up / task" onClick={() => go("/crm?tab=tasks")} />
          <Row icon="🚗" label="Start a mileage trip" onClick={() => go("/mileage")} />
          <Row icon="📣" label="New social post idea" onClick={() => go("/social")} />
        </div>
        <button onClick={onClose} className="mt-2 w-full py-3 text-center text-sm font-semibold text-slate-400">
          Cancel
        </button>
      </div>
    </div>
  );
}
